import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { createTask, createTasks } from 'actions/tasks';

import { ResourceListItemCreate } from 'components/ResourceList';

const EMPTY_OBJECT = {};

const CreateListTaskItem = ({ autoFocus, placeholder, taskProps = EMPTY_OBJECT, excludedTasks, autoCreate = true, onCreate, onProjectChange, onTaskSelect }) => {
    const { t } = useTranslation('task');

    const handleCreate = useCallback(async names => {
        if (autoCreate) {
            if (names.length === 1) {
                await createTask({
                    name: names[0],
                    ...taskProps
                });
            } else {
                await createTasks(names.map(name => ({
                    name: (name || '').trim(),
                    ...taskProps
                })));
            }
        }

        onCreate?.(names);

        return true;
    }, [autoCreate, taskProps, onCreate]);

    return (
        <ResourceListItemCreate
            resourceType="task"
            excludedResources={excludedTasks}
            placeholder={placeholder || `${t('Add a new task')}...`}
            autofocus={autoFocus}
            autofocusDelay={300}
            projectId={taskProps?.project}
            onProjectChange={onProjectChange}
            onSelect={onTaskSelect}
            onCreate={handleCreate}
        />
    );
}

export default CreateListTaskItem;
